/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reorder an action's rules.
 * 
 * Clients send order, never numbers: the server assigns 0..n-1. The id set must match the
 * action's rules exactly, so a stale client cannot drop a rule out of the ordering and leave
 * it at a colliding position.
 * @export
 * @interface RuleReorderRequest
 */
export interface RuleReorderRequest {
    /**
     * 
     * @type {string}
     * @memberof RuleReorderRequest
     */
    transitionAction: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleReorderRequest
     */
    ruleIds: Array<string>;
}

/**
 * Check if a given object implements the RuleReorderRequest interface.
 */
export function instanceOfRuleReorderRequest(value: object): value is RuleReorderRequest {
    if ((!('transitionAction' in (value as Record<string, any>)) && !('transition_action' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionAction'] === undefined && (value as Record<string, any>)['transition_action'] === undefined)) return false;
    if ((!('ruleIds' in (value as Record<string, any>)) && !('rule_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['ruleIds'] === undefined && (value as Record<string, any>)['rule_ids'] === undefined)) return false;
    return true;
}

export function RuleReorderRequestFromJSON(json: any): RuleReorderRequest {
    return RuleReorderRequestFromJSONTyped(json, false);
}

export function RuleReorderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleReorderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transitionAction': json['transition_action'],
        'ruleIds': json['rule_ids'],
    };
}

export function RuleReorderRequestToJSON(json: any): RuleReorderRequest {
    return RuleReorderRequestToJSONTyped(json, false);
}

export function RuleReorderRequestToJSONTyped(value?: RuleReorderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition_action': value['transitionAction'],
        'rule_ids': value['ruleIds'],
    };
}

